var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33335 4.99984H1.66669V16.6665C1.66669 17.5832 2.41669 18.3332 3.33335 18.3332H15V16.6665H3.33335V4.99984ZM16.6667 1.6665H6.66669C5.75002 1.6665 5.00002 2.4165 5.00002 3.33317V13.3332C5.00002 14.2498 5.75002 14.9998 6.66669 14.9998H16.6667C17.5834 14.9998 18.3334 14.2498 18.3334 13.3332V3.33317C18.3334 2.4165 17.5834 1.6665 16.6667 1.6665ZM15.8334 9.1665H7.50002V7.49984H15.8334V9.1665ZM12.5 12.4998H7.50002V10.8332H12.5V12.4998ZM15.8334 5.83317H7.50002V4.1665H15.8334V5.83317Z",
    fill: "#6F7486"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.498b8166e7850dcf4df216a5218603f4.svg";
export { ForwardRef as ReactComponent };